import {
  Button,
  OdinIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  TabView,
  TabViewPanel,
} from '@myosh/odin-components';
import { memo, useCallback, useRef, useState } from 'react';
import DisplayFilterTab, { type DisplayFilterTabRef } from './display-filter-tab.component';

function FilterOverlay() {
  const [isFilterOverlayOpen, setIsFilterOverlayOpen] = useState(false);

  const displayFilterTabRef = useRef<DisplayFilterTabRef>(null);

  const closeFilterOverlay = useCallback(() => {
    setIsFilterOverlayOpen(false);
  }, []);

  const handleSave = useCallback(() => {
    displayFilterTabRef.current?.save();
    closeFilterOverlay();
  }, []);

  return (
    <Popover open={isFilterOverlayOpen} onOpenChange={setIsFilterOverlayOpen}>
      <PopoverTrigger>
        <OdinIcon icon="Filter" className="text-primary-1 hover:bg-primary-5 rounded-md" />
      </PopoverTrigger>
      <PopoverContent align="start" data-cy="filter-overlay-panel">
        <TabView
          headerClassName="font-medium text-base"
          className="hover:text-primary-1 text-gray-3 mr-4 cursor-pointer font-medium"
          activeIndex={0}
        >
          <TabViewPanel header="Display">
            <DisplayFilterTab ref={displayFilterTabRef} />
          </TabViewPanel>
        </TabView>
        <Button data-cy="filter-overlay-apply-button" onClick={handleSave}>
          Apply
        </Button>
      </PopoverContent>
    </Popover>
  );
}

export default memo(FilterOverlay);
